import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useGetMyMonthLogQuery } from "../../api/dailyLogApi";
import LoadingView from "../../components/ui/LoadingView";
import { localDateString, monthKey, parseLocalDate } from "../../lib/dateUtils";
import DateNavigator from "./components/DateNavigator";
import "../profile/darkSurface.css";
import LogEntryEditor from "./components/LogEntryEditor";
import ConnectionState from "../../components/ui/ConnectionState";

function findDayLog(monthData, localDate) {
  const list = monthData?.data?.dailyLogs || [];
  return list.find((l) => l.date === localDate) || null;
}

export default function ResultsPage() {
  const { t } = useScriptMode();
  const [searchParams, setSearchParams] = useSearchParams();
  const queryDate = searchParams.get("date");
  const initialDate = parseLocalDate(queryDate) || new Date();
  const [date, setDate] = useState(localDateString(initialDate));

  // Sync URL when date changes
  useEffect(() => {
    if (queryDate !== date) {
      setSearchParams({ date }, { replace: true });
    }
  }, [date, queryDate, setSearchParams]);

  const mk = monthKey(parseLocalDate(date) || new Date());
  const { data, isLoading, isFetching, isError, error, refetch } = useGetMyMonthLogQuery({ monthKey: mk });

  const dayLog = findDayLog(data, date);

  return (
    <div className="tk-dark max-w-6xl mx-auto flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-SemiBold text-terakkiPrimaryDark">{t("results_title")}</h1>
        <DateNavigator value={date} onChange={setDate} />
      </div>

      {isLoading ? (
        <LoadingView label={t("loading")} />
      ) : isError ? (
        <ConnectionState error={error} onRetry={refetch} retrying={isFetching} />
      ) : (
        <LogEntryEditor
          key={date}
          localDate={date}
          dayLog={dayLog}
          onSaved={refetch}
        />
      )}
    </div>
  );
}
